/**
 * Pure per-order variant of the `getOrderLoyaltyRedeemTransferEligibility` selector — basic
 * transfer eligibility without the experience-data dependency. Use when the order is not the
 * route-viewed order (e.g. the upcoming-escapes card). `isInternationalTrip` should be computed
 * for the same order (e.g. via `isOrderInternationalTrip`).
 */
export default function determineOrderLoyaltyRedeemTransferEligibility(
  order: App.Order | undefined,
  userBenefits: Array<App.LoyaltyBenefit> | undefined,
  isInternationalTrip: boolean,
  isCurrentRegionUserLoyaltyRegion: boolean,
  airportCodes: ReadonlyArray<unknown>,
  isTasteOfGoldEligibleOrder: boolean,
): boolean {
  if (!isCurrentRegionUserLoyaltyRegion || !order?.loyaltyDetails.tier) return false

  const hasRedeemedTransfer = order.loyaltyDetails.benefitsRedeemed.some(
    benefit => benefit.code === 'airport_transfer' && benefit.status === 'ISSUED',
  )
  if (hasRedeemedTransfer) return false

  const transferBenefit = userBenefits?.find(benefit => benefit.code === 'airport_transfer')
  const hasTransferBenefit = !!transferBenefit && (transferBenefit.unlimited || !!transferBenefit.remaining)

  return airportCodes.length > 0 &&
    (hasTransferBenefit || isTasteOfGoldEligibleOrder) &&
    isInternationalTrip
}
